import React from "react";
import '../CSS Styling/Footer.css';
function Footer()
{
    return <div className="footer-container">
        <div className="footer-text">
        ©2023, All rights reserved, Saikat Mohanta
        </div>
    </div>
}

export default Footer;